export const EDGE_MARGIN = 16;

// Horizontal space a panel shares with its sibling: the viewport minus the
// left nav, whose width MainLayout publishes as --sidebar-width.
const getAvailableWidth = (): number => {
  if (typeof window === "undefined") return Infinity;
  const sidebar =
    parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--sidebar-width",
      ),
      10,
    ) || 0;
  return window.innerWidth - sidebar;
};

export const wouldSidePanelTakeOver = (
  minWidth: number,
  minSiblingWidth: number,
  availableWidth: number = getAvailableWidth(),
): boolean =>
  minSiblingWidth > 0 &&
  availableWidth < minWidth + minSiblingWidth + EDGE_MARGIN * 2;
